import { c as _c } from "react/compiler-runtime";
import { Switch } from '@/components/ui/switch';
import { cva } from 'class-variance-authority';
import { ComponentProps } from 'react';
type ViverseSwitchProps = ComponentProps<typeof Switch> & {
  variant?: 'default';
};
const switchVariants = cva('', {
  variants: {
    variant: {
      default: 'data-[state=unchecked]:bg-vive-primary-70 [&>span]:bg-vive-primary-20'
    }
  }
});
function ViverseSwitch(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[3] !== variant) {
    t2 = switchVariants({
      variant
    });
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== t2) {
    t3 = <Switch {...props} className={t2} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default ViverseSwitch;